import style from './spinner.module.css'

const Spinner = () => <div className={style.loader}></div>;

export default Spinner;